var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClusters = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  viewBox: "0 0 22 22"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M12 10C12 8.343 10.657 7 9 7 7.343 7 6 8.343 6 10 6 11.657 7.343 13 9 13 10.657 13 12 11.657 12 10zM3.999 3.7549C2.171 5.2219 1 7.4739 1 9.9999 1 11.4569 1.39 12.8229 2.07 13.9999M16.9385 9C16.4465 5.054 13.0795 2 9.0005 2M7 17.748C7.639 17.912 8.31 18 9 18 11.961 18 14.546 16.392 15.93 14"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9 0C7.896 0 7 .896 7 2 7 3.104 7.896 4 9 4 10.104 4 11 3.104 11 2 11 .896 10.104 0 9 0M2.0703 12C1.7303 12 1.3863 12.086 1.0723 12.268.1153 12.82-.2127 14.043.3403 15 .7103 15.642 1.3833 16 2.0733 16 2.4133 16 2.7573 15.914 3.0723 15.732 4.0283 15.18 4.3563 13.957 3.8033 13 3.4333 12.358 2.7603 12 2.0703 12M15.9297 12C15.2397 12 14.5667 12.358 14.1967 13 13.6437 13.957 13.9717 15.18 14.9277 15.732 15.2427 15.914 15.5867 16 15.9267 16 16.6167 16 17.2897 15.642 17.6597 15 18.2127 14.043 17.8847 12.82 16.9277 12.268 16.6137 12.086 16.2697 12 15.9297 12"
}))));
export default SvgClusters;